import Modal from 'react-modal';
const CustomModal = Modal as unknown as React.FC<any>;

export default CustomModal;